import React from "react";
import { Link } from "@material-ui/core";

export default ({ href, children }) => {
  if (!href) return <span>-</span>;
  return (
    <Link href={href} target="_blank" rel="noopener noreferrer">
      {children || href}
    </Link>
  );
};
